import i18n from '@/localization';

export const getErrorMessages = (
  errorData,
  fieldName,
  fieldNamePretty,
  min
) => {
  const list = [];
  if (errorData) {
    const collect = errorData.collect(fieldName, null, false);
    if (collect) {
      collect.forEach((error, index) => {
        const fieldRuleMessage = i18n.te(
          `validations.${fieldName}.${error.rule}`
        );
        const ruleMessage = i18n.te(`validations.${error.rule}`);
        if (fieldRuleMessage || ruleMessage) {
          list[index] = i18n.t(
            `validations.${fieldRuleMessage ? `${fieldName}.` : ''}${
              error.rule
            }`,
            {
              field_name: fieldNamePretty ? fieldNamePretty : fieldName,
              min: min ? min : '',
            }
          );
        } else {
          list[index] = error.msg;
        }
      });
    }
  }
  return list;
};

export const getServerUrl = () => {
  return window.location.origin;
};

export const isReachable = url => {
  return fetch(url, { method: 'HEAD', mode: 'no-cors' })
    .then(function(resp) {
      return resp && (resp.ok || resp.type === 'opaque');
    })
    .catch(function(err) {
      console.warn('[conn test failure]:', err);
    });
};

export const POINTS_FIXED_LIST = [5, 10, 15, 25, 50];

export const GAME_STATUSES = {
  SCHEDULED: 'SCHEDULED',
  LIVE: 'LIVE',
  COMPLETED: 'COMPLETED',
};

export const PREDICTION_TYPES = {
  HIT: i18n.t('prediction_types.hit'),
  SINGLE: i18n.t('prediction_types.single'),
  DOUBLE: i18n.t('prediction_types.double'),
  TRIPLE: i18n.t('prediction_types.triple'),
  HOME_RUN: i18n.t('prediction_types.home_run'),
  OUT: i18n.t('prediction_types.out'),
  FLY_OUT: i18n.t('prediction_types.fly_out'),
  GROUND_OUT: i18n.t('prediction_types.ground_out'),
  GO789: i18n.t('prediction_types.go789'),
  WALK: i18n.t('prediction_types.walk'),
  STRIKE: i18n.t('prediction_types.strike'),
};

export const COUNTDOWN_MINUTES = 15;

export const GENERAL_EVENTS = {
  GAME_UPDATE: 'GAME_UPDATE',
  DUELS_UPDATE: 'DUELS_UPDATE',
};

export const INGAME_EVENTS = {
  STOP_PREDICTIONS: 'STOP_PREDICTIONS',
  START_PREDICTIONS: 'START_PREDICTIONS',
  POST_RESULTS: 'POST_RESULTS',
  VOID_RESULTS: 'POST_RESULTS',
  NEXT_COMPETITION: 'NEXT_COMPETITION',
  CANCEL_RESULTS: 'CANCEL_RESULTS',
  END_HALF_INNING: 'END_HALF_INNING',
};

export const GAME_ACTIONS = {
  START_PREDICTIONS: i18n.t('game_actions.start_predictions'),
  STOP_PREDICTIONS: i18n.t('game_actions.stop_predictions'),
  POST_RESULTS: i18n.t('game_actions.post_results'),
  CANCEL_RESULTS: i18n.t('game_actions.cancel_results'),
  END_HALF_INNING: i18n.t('game_actions.end_half_inning'),
  VOID_RESULTS: i18n.t('game_actions.void_results'),
  GAME_UPDATE: i18n.t('game_actions.game_update'),
  DUELS_UPDATE: i18n.t('game_actions.duels_update'),
};

export const CONNECTIVITY_STATUSES = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  UNREACHABLE: 'UNREACHABLE',
};
